import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';
import { FileUploadModule } from 'ng2-file-upload';

import { CondicaoPagamentoRoutingModule } from './condicao-pagamento-routing.module';
import { CondicaoPagamentoComponent } from './condicao-pagamento.component';
import { CondicaoPagamentoFormComponent} from './form';
import { CondicaoPagamentoFilterCollapseComponent } from './filter';
import { CondicaoPagamentoPrazoComponent } from './prazo';
import { CondicaoPagamentoImportModalComponent } from './import-modal';

@NgModule({
    imports: [
        SharedModule,
        CondicaoPagamentoRoutingModule,
        FileUploadModule
    ],
    declarations: [
        CondicaoPagamentoComponent,
        CondicaoPagamentoFormComponent,
        CondicaoPagamentoFilterCollapseComponent,
        CondicaoPagamentoPrazoComponent,
        CondicaoPagamentoImportModalComponent
    ]
})
export class CondicaoPagamentoModule { }
